import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { GetUserPreferencesResponse, Preferences } from '../../../models/dtos';
import { PreferencesService } from '../../../services/preferences/preferences.service';
import { MaterialIndicatorsOptionId } from '../../../models/enum';
import { MaterialIndicatorOption } from '../../../models/common/MaterialIndicator';
import { CommonDataService } from '../../../services/common-data.service';
import { MatMenuModule } from '@angular/material/menu';


@Component({
  selector: 'app-material-indicator',
  imports: [CommonModule, TranslatePipe, MatIcon, MatMenuModule],
  templateUrl: './material-indicator.component.html',
  styleUrl: './material-indicator.component.scss'
})
export class MaterialIndicatorComponent implements OnInit {
  selectedOptionId: string = '';
  propertiesOptionId = MaterialIndicatorsOptionId;
  preferencesObject: Preferences = new Preferences();
  // Maps option IDs to corresponding preference keys for toggling
  private readonly prefKeyByOption: Record<string, 'showRPNMaterialIndicator' | 'showAPNMaterialIndicator' | 'showUPNMaterialIndicator' | 'showePartsMaterialIndicator'> = {
    [MaterialIndicatorsOptionId.SHOW_RPN]: 'showRPNMaterialIndicator',
    [MaterialIndicatorsOptionId.SHOW_APN]: 'showAPNMaterialIndicator',
    [MaterialIndicatorsOptionId.SHOW_UPN]: 'showUPNMaterialIndicator',
    [MaterialIndicatorsOptionId.SHOW_Si_PARTS]: 'showePartsMaterialIndicator'
  };

  // Derived state for template bindings to avoid method calls
  enabledIndicatorMap: Record<string, boolean> = {};

  materialIndicatorOptions: MaterialIndicatorOption[] = [
    {
      id: MaterialIndicatorsOptionId.SHOW_RPN,
      label: 'MATERIAL_INDICATOR_SHOW_RPN'
    },
    {
      id: MaterialIndicatorsOptionId.SHOW_APN,
      label: 'MATERIAL_INDICATOR_SHOW_APN'
    },
    {
      id: MaterialIndicatorsOptionId.SHOW_UPN,
      label: 'MATERIAL_INDICATOR_SHOW_UPN'
    },
    {
      id: MaterialIndicatorsOptionId.SHOW_Si_PARTS,
      label: 'MATERIAL_INDICATOR_SHOW_SIPARTS'
    }
  ];


  constructor(
    private readonly commonDataService: CommonDataService,
    private readonly preferencesService: PreferencesService
  ) { }

  ngOnInit(): void {
    this.checkUserPreferences();
  }

    checkUserPreferences() {
      const userPreferencesData: GetUserPreferencesResponse = this.commonDataService.getPreferenceData();
      if (userPreferencesData && userPreferencesData.preferences) {
        this.preferencesObject = userPreferencesData.preferences;
        this.updateEnabledIndicators();
      }
  }

  selectOption(optionId: string, event: MouseEvent) {
    event.stopPropagation();
    this.commonDataService.setSelectedMaterialIndicatorId(optionId);
    const key = this.prefKeyByOption[optionId];
    if (!key) {
      return;
    }
    this.preferencesObject[key] = !this.preferencesObject[key];
    this.updateEnabledIndicators();
    this.preferencesService.saveUserPreferenceData(this.preferencesObject);
  }

  private updateEnabledIndicators(): void {
    this.enabledIndicatorMap = {
      [MaterialIndicatorsOptionId.SHOW_RPN]: this.preferencesObject.showRPNMaterialIndicator,
      [MaterialIndicatorsOptionId.SHOW_APN]: this.preferencesObject.showAPNMaterialIndicator,
      [MaterialIndicatorsOptionId.SHOW_UPN]: this.preferencesObject.showUPNMaterialIndicator,
      [MaterialIndicatorsOptionId.SHOW_Si_PARTS]: this.preferencesObject.showePartsMaterialIndicator,
    };
  }

  trackByOptionId(index: number, option: MaterialIndicatorOption): string {
    return option.id;
  }

}
